import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const mock = [
    {
        content:
            'The Scientific Committee invites who are interested in sharing their work with the participants of the meeting, to submit their work in abstract and clinical case submission. Please follow the instructions given below and make sure that each field in the abstract form has been completed.',
    },
    {
        content:
            'The winner for the best Abstract / Case for each category will walk home with cash rewards!',
    },
];
const Main = () => {
    return (
        <Box>
            <Box marginBottom={4}>
                <Typography
                    variant="h4"
                    align={'center'}
                    data-aos={'fade-up'}
                    color={'text.white'}
                    gutterBottom
                    sx={{
                        fontWeight: 'bold',
                    }}
                >
                    CALL FOR ABSTRACT
                </Typography>
                <Typography
                    variant="h6"
                    align={'center'}
                    color={'text.white'}
                    data-aos={'fade-up'}
                >
                    Deadline for submission: 15 Januari 2022
                </Typography>
                <Grid container mt={1} spacing={4}>
                    {mock.map((item, i) => (
                        <Grid item key={i} sm={12} md={6}>
                            <Box
                                data-aos={'fade-up'}
                                sx={{
                                    border: 'solid white 1px',
                                    height: { sx: 'auto', sm: 'auto', md: 143 },
                                    borderRadius: 4,
                                    padding: 2,
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    align={'justify'}
                                    color={'text.white'}
                                    data-aos={'fade-up'}
                                >
                                    {item.content}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
                <Box
                    display="flex"
                    justifyContent={'unsafe center'}
                    marginTop={2}
                >
                    <Button
                        variant="contained"
                        color="success"
                        size="large"
                        sx={{
                            marginRight: 4,
                        }}
                    >
                        <Typography align={'center'} color={'text.white'}>
                            Submission Guidelines
                        </Typography>
                    </Button>
                    <Button variant="contained" color="success" size="large">
                        <Typography align={'center'} color={'text.white'}>
                            Submission How To
                        </Typography>
                    </Button>
                </Box>
                <Box display="flex" justifyContent={'center'} marginTop={2}>
                    <Button variant="contained" color="success" size="large">
                        <Typography align={'center'} color={'text.white'}>
                            Submit Now
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default Main;
